import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { CustomerwelcomeService } from './service/customerwelcome.service';
import { Customerwelcome } from './model/customerwelcome';
import { UieventhubService } from '@src/app/helpers/uieventhub/uieventhub.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-customerwelcome',
  templateUrl: './customerwelcome.component.html',
  styleUrls: ['./customerwelcome.component.css']
})
export class CustomerwelcomeComponent {
  custwelcome: Customerwelcome;
  customerId: string;
  showSpinner: boolean = true;
  @Input() quill: boolean;
  constructor(private cwsrv: CustomerwelcomeService,
    private uieventhub: UieventhubService
  ) { }

  ngOnInit() {
    this.uieventhub.addLoader('customerwelcome');

    this.customerId = JSON.parse(SessionHelper.getCustomer()).customerId.split('_')[0];

    if (this.customerId) {
      this.cwsrv.getWelcomeMessage(this.customerId).pipe(untilDestroyed(this)).subscribe(
        (data: Customerwelcome) => {
          if (!data || typeof data !== 'object') {
            this.showSpinner = false;
            this.uieventhub.removeLoader('customerwelcome');
            return;
          }
          this.custwelcome = data;
          this.custwelcome.markup = this.parseHtml();
          this.custwelcome.markup = this.parseHtml2();
          this.showSpinner = false;
          this.uieventhub.removeLoader('customerwelcome');
        }
      );
    }

  }

  parseHtml() {
    return (this.custwelcome.markup ?? '').replace('[username]', SessionHelper.getUserName());
  }

  parseHtml2() {
    return (this.custwelcome.markup ?? '').replace(new RegExp("<p></p>", 'g'), "<br>");
  }

}
